import { ABP } from '@abp/ng.core';
import { EntityDto } from './base';
import { AppModuleManagement } from './app-module-management';

export namespace TerminalManagement {

    export interface State {
        terminals: TerminalResponse,
        selectedTerminal: TerminalItem;
        currentTerminalSettings: AppModuleManagement.AppTerminalSettingItem
    }

    export interface RegisterRequest {
        tenantId: string;
        display: string;
        description: string;
        machineCode: string;
        terminalType: string;
    }

    export enum TerminalType {
        App = 0,
        Service = 1
    }

    export interface GetTerminalsRequest extends ABP.PageQueryParams {
        tenantId: string;
    }

    export interface TerminalItem extends EntityDto {
        tenantId: string;
        display: string;
        description: string;
        machineCode: string;
        terminalType: string;
        enabled: boolean;
        authToken: string;
    }

    export type TerminalResponse = ABP.PagedResponse<TerminalItem>;

    export interface UpdateTerminalRequest {
        id: string
        display: string;
        description: string;
    }



}
